<template name="photoSwipe">
  <div class="photoSwipe" @click="closePhoto">
    <div class="contain" v-if="imgs.length">
      <swiper :options="swiperOption">
  　　  <swiper-slide v-for="(items,index) in imgs">
  　　　  <img class="slide-img" style="width: 100%; height: 100%;" :src="items" alt="">
  　　  </swiper-slide>
      </swiper>
      <div class="swiper-pagination" slot="pagination"></div>
    </div>
    <div class="url-position" v-if="marterial.length">
      <div class="url-list" v-for="(item,idx) in marterial">
        <a :href="item.url" target="_blank">
         {{ item.name }}
        </a>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import Swiper from 'swiper/dist/js/swiper.js';
import 'swiper/dist/css/swiper.min.css';

export default {
  name: 'photoSwipe',
  data() {
    return {
      imgs: [],
      swiperOption: {
    　　pagination: {
          el: '.swiper-pagination',
          clickable: true,
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            return '<div class="list-point"><span class="list">'+current+'</span><span>' + ' /' + total+'</span></div>';
          }
        },
        notNextTick: true,
        centeredSlides: true,
    　　paginationClickable: true,
    　　autoplay: 2500,
    　　autoplayDisableOnInteraction: false,
    　　loop: true,
        initialSlide: 0,
    　　coverflow: {
  　　　　rotate: 30,
  　　　　stretch: 10,
  　　　　depth: 60,
  　　　　modifier: 2,
  　　　　slideShadows : true
    　　},
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        zoom: {
         maxRatio: 5, //最大倍数
         minRatio: 2, //最小倍数
         toggle: true, //不允许双击缩放，只允许手机端触摸缩放。
         containerClass: 'my-zoom-container', //zoom container 类名
        },
      },
      marterial: [],
    }
  },
  mounted() {
    var that = this;
    // this.$nextTick(function() {
    //   that.scroll();
    // })
  },
  methods: {
    scroll() {
      new Swiper ('.swiper-container', {
        loop: true,
        pagination: '.swiper-pagination',
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      });
    },
    loadPhoto(Data) {

      this.imgs = Data;
      this.marterial = [];
    },
    closePhoto(event) {
      const isTapImg = event.target.tagName.toLowerCase() === 'img';
      if (!isTapImg) {
        this.imgs = [];
        this.marterial = [];
        this.$emit('closePhoto', true);
      }
    },
    loadMaterial(url,name) {
      const marterialList = [];
      for (var i = 0; i<url.length;i++) {
        const marterial = {
          'url': url[i],
          'name': name[i],
        }
        marterialList.push(marterial);
      }
      // console.log(marterialList);
      this.marterial = marterialList;
      this.imgs = [];
    }
  }
}

</script>
<style lang="scss">
  @import "../scss/variables.scss";
  .photoSwipe {
    height: 100vh;
  }
  .url-position {
    position: fixed;
    top: 50%;
    left:50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    background: #fff;
    width: 400px;
    @include respond-to('sm-max') {
      width: 90%;
    }
    @include respond-to('ml') {
      width: 400px;
    }
    .url-list {
      margin: 20px;
     a {
      color: #000;
      text-decoration: underline;
     }
    }
  }
  .contain {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 80%;
    height: 90vh;
    margin: auto;
    overflow: hidden;
    overflow-y: auto;
    display: flex;
    align-items: center;
    // @include respond-to('xs') {
    //     width: 300px;
    //     height: 300px;
    //     margin: 0 auto;
        
    // }
    // @include respond-to('sm') {
    //     width: 300px;
    //     margin: 0 auto;
    // }
    // @include respond-to('md') {
    //     width: 600px;
    //     height: 600px;
    //     margin: 0% auto;
    //     position: relative;
    //     margin-top: 90px;
    //     left: inherit;
    //     top: inherit;
    //     transform: none;
    // }
    // @include respond-to('lg') {
    //     width: 900px;
    //     height: 900px;
    //     margin: 0% auto;
    //     position: relative;
    //     margin-top: 70px;
    //     left: inherit;
    //     top: inherit;
    //     transform: none;
    // }
    // @include respond-to('xl') {
    //     width: 900px;
    //     height: 900px;
    //     margin: 0% auto;
    //     margin-top: 70px;
    // }
  }
  .swiper-container {
    position: relative;
    height: auto;
    width: 100%;
    // @include respond-to('xs') {
    //     width: 300px;
    //     height: 250px;
    //     margin: 0% auto;
    // }
    // @include respond-to('sm') {
    //     width: 300px;
    // }
    // @include respond-to('md') {
    //     width: 600px;
    //     height: 450px;
    // }
    // @include respond-to('lg') {
    //     width: 900px;
    //     height: 500px;
    // }
    // @include respond-to('xl') {
    //     width: 900px;
    //     height: 500px;
    // }
    .swiper-wrapper {
      display: flex;
      align-items: center;
    }
  }
  .close-photo {
    position: relative;
    height: auto;
  }
  .swiper-button-next, .swiper-button-prev {
    
    @include respond-to('xs') {
        margin-top: -45%;
    }
    @include respond-to('sm') {
        margin-top: -45%;
    }
    @include respond-to('md') {
        margin-top: -40%;
    }
    @include respond-to('lg') {
        margin-top: -29.5%;
    }
    @include respond-to('xl') {
        margin-top: -29.5%;
    }
  }
  .next-list {
    position: relative;
  }
  .swiper-pagination-bullet-active {
    background: red!important;
  }
  .swiper-pagination-bullet {
    background: #FFF;
    opacity: 1
  }
  .list-point {
    width: 35px;
    float: right;
    color: #fff;
    background: rgba(0,0,0,0.3);
    border-radius: 10px;
    font-size: 12px;
  }
  .swiper-slide {
    text-align: center;
    img.slide-img {
      width: auto !important;
      height: auto !important;
      max-width: 100%;
      margin: auto;
      object-fit: contain;
      max-height: 90vh;
      display: block;
    }
  }
  .close-photo {
    position: absolute;
    top:15px;
    right: 10px;
    & > div {
      cursor: pointer;
      position: absolute;
      right: -8px;
      top: -11px;
      z-index: 2000;
      width: 25px;
      img {
        width: 25px;
        height: 25px;
      }
    }
  }
</style>
